import React from "react";

import { Theme, useTheme } from "@mui/material/styles";

import { InvoiceItemViewProps, ShippingCartType } from "./ShippingCart.types";
import {
  formatDate,
  formatLocalizedMoney,
  logDebug,
  mergeProperties,
} from "packable-components";
import { Divider, Grid, Typography } from "@mui/material";

import "./ShippingCart.css";

const useStyles = (theme: Theme) => ({
  InvoiceItemViewContainer: {
    width: "100%",
    pb: 2,
  },
  InvoiceItemViewContainerDivider: {
    mb: 2,
  },
  InvoiceItemViewRowContainer: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "center",
  },
  InvoiceItemViewSingleItemRowContainer: {
    width: "512px",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  InvoiceItemViewContentShortTextFieldContainer: {
    padding: 1,
  },
  InvoiceItemViewContentShortTextField: {
    width: "240px",
  },
  InvoiceItemViewContentFullWidthTextFieldContainer: {
    width: "100%",
    padding: 1,
  },
  InvoiceItemViewContentActionRow: {
    padding: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  InvoiceItemViewContentActionRemoveButton: {
    muiVariant: "contained",
    muiColor: "secondary",
  },
});

export const InvoiceItemView: React.FC<InvoiceItemViewProps> = (
  props
): React.JSX.Element => {
  const { shippingCartType, shippingCartItemPrice, styles } =
    props;

  logDebug("InvoiceItemView PROPS");
  logDebug(props);

  const theme = useTheme();

  const defaultStyles = useStyles(theme);
  const effectiveStyles =
    styles === undefined
      ? defaultStyles
      : mergeProperties(defaultStyles, styles);

  logDebug("InvoiceItemView effectiveStyles");
  logDebug(effectiveStyles);

  const getItemLabel = (): string => {
    if (shippingCartType === ShippingCartType.STORAGE) {
      return `${
        shippingCartItemPrice.itemLabel
      } store until ${formatDate(
        new Date(shippingCartItemPrice.storageEndDate).toDateString(),
        Intl.DateTimeFormat().resolvedOptions().locale, 
        { dateStyle: "short" }
      )}`;
    }
    return shippingCartItemPrice.itemLabel;
  };

  return (
    <Grid
      className="InvoiceItemViewContainer"
      sx={effectiveStyles.InvoiceItemViewContainer}
    >
      <Divider
        className="InvoiceItemViewContainerDivider"
        sx={effectiveStyles.InvoiceItemViewContainerDivider}
      />
      <Grid
        className="InvoiceItemViewRowContainer"
        sx={effectiveStyles.InvoiceItemViewRowContainer}
      >
        <Grid sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
          <Typography variant="body1">{getItemLabel()}</Typography>
          <Typography variant="body2">
            {`Item Sub-Total: ${formatLocalizedMoney(
              shippingCartItemPrice.subTotal,
              2,
              shippingCartItemPrice.currency,
              Intl.DateTimeFormat().resolvedOptions().locale
            )}`}
          </Typography>
          <Typography variant="body2">
            {`Tax: ${formatLocalizedMoney(
              shippingCartItemPrice.tax,
              2,
              shippingCartItemPrice.currency,
              Intl.DateTimeFormat().resolvedOptions().locale
            )}`}
          </Typography>
          <Typography variant="body2">
            {`Item Total: ${formatLocalizedMoney(
              shippingCartItemPrice.total,
              2,
              shippingCartItemPrice.currency,
              Intl.DateTimeFormat().resolvedOptions().locale
            )}`}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        className="InvoiceItemViewRowContainer"
        sx={effectiveStyles.InvoiceItemViewRowContainer}
      ></Grid>
      <Grid
        className="InvoiceItemViewSingleItemRowContainer"
        sx={effectiveStyles.InvoiceItemViewSingleItemRowContainer}
      ></Grid>
    </Grid>
  );
};
